import { Icon, IconProps } from ".";

export const Refresh = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        d="M7.995 5V6.99834H5.9975V8.99667H4V15.0017H5.9975V17H8V19H10V17H8.00499V14.9917H6.00749V9.00666H8.00499V7.00832H14L14 9H16V13H13V14.2118H14.3334V15.4236H15.6669V16.6354H18.3337V15.4236H19.6666V14.2118H21L20.9999 13H18V9H16V7H14L14 5H7.995Z"
        fill="currentColor"
      />
    </Icon>
  );
};
